module.exports = __webpack_public_path__ + "static/media/logo.996005d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/header/images/logo.png
// module id = 528
// module chunks = 0